import { ArrowRightLeft, Building2, CircleCheck, LoaderCircle } from "lucide-react";

type AccountTransitionOverlayProps = {
  open: boolean;
  title: string;
  targetLabel?: string;
  detail: string;
  completedStep?: string;
  activeStep: string;
};

/**
 * Hesap ve tenant geçişleri sırasında eski bağlamda işlem yapılmasını önleyen,
 * kullanıcının neden beklediğini açıkça anlatan ortak tam ekran katman.
 */
export default function AccountTransitionOverlay({
  open,
  title,
  targetLabel,
  detail,
  completedStep,
  activeStep,
}: AccountTransitionOverlayProps) {
  if (!open) return null;

  return (
    <div
      role="status"
      aria-live="assertive"
      aria-busy="true"
      className="fixed inset-0 z-[12000] isolate grid place-items-center overflow-y-auto bg-slate-950/80 px-4 py-[max(1rem,env(safe-area-inset-top))] backdrop-blur-md animate-fade-in"
      style={{ height: "var(--app-visual-height, 100dvh)" }}
      data-account-transition-overlay
    >
      <section className="w-full max-w-sm overflow-hidden rounded-3xl border border-panel-accent/30 bg-panel-card/95 p-5 text-center shadow-2xl shadow-black/40">
        <div className="relative mx-auto grid h-20 w-20 place-items-center">
          <span className="absolute inset-0 rounded-full border border-panel-accent/20 bg-panel-accent/5" />
          <span className="absolute inset-1 rounded-full border-2 border-transparent border-r-panel-accent border-t-panel-accent animate-spin motion-reduce:animate-none" />
          <span className="grid h-12 w-12 place-items-center rounded-2xl border border-panel-accent/30 bg-panel-bg text-panel-accent shadow-glow">
            <ArrowRightLeft size={22} className="animate-pulse motion-reduce:animate-none" />
          </span>
        </div>

        <h2 className="mt-4 text-base font-semibold text-panel-text">{title}</h2>
        {targetLabel && (
          <div className="mx-auto mt-2 flex max-w-full items-center justify-center gap-2 rounded-xl border border-panel-border bg-panel-bg/70 px-3 py-2 text-sm">
            <Building2 size={15} className="shrink-0 text-panel-accent" />
            <span className="truncate font-medium">{targetLabel}</span>
          </div>
        )}
        <p className="mt-3 text-xs leading-relaxed text-panel-muted">{detail}</p>

        <div className="mt-4 space-y-2 rounded-2xl border border-panel-border bg-panel-bg/55 p-3 text-left text-xs">
          {completedStep && (
            <div className="flex items-center gap-2 text-panel-success">
              <CircleCheck size={15} className="shrink-0" />
              <span>{completedStep}</span>
            </div>
          )}
          <div className="flex items-center gap-2 text-panel-text">
            <LoaderCircle size={15} className="shrink-0 animate-spin text-panel-accent motion-reduce:animate-none" />
            <span>{activeStep}</span>
          </div>
        </div>

        <p className="mt-3 text-[10px] leading-relaxed text-panel-muted">
          Güvenli geçiş tamamlanana kadar bu pencere otomatik olarak açık kalır.
        </p>
      </section>
    </div>
  );
}
